import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        state: 'contact_number',
        userType: 'farmer' //farmer, subdist, dist, sale
    },
	actions: {

	},
	mutations: {
        changeState (state, stateName) {
          state.state = stateName;
        },
        changeUserType (state, userType) {
            state.userType = userType;
        },
      },
	getters:{

	}
});
